export default __webpack_public_path__ + "static/moneyforward-471963f2e4348131b6f788442ad87bc6.png";